import { inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hoursToDecimal',
})
export class HoursToDecimalPipe implements PipeTransform {
  private locale = inject(LOCALE_ID);

  transform(time: string): string {
    const [hours, minutes] = time.split(':').map(Number);
    const decimal = hours + minutes / 60;
    return decimal.toLocaleString(this.locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
}
